<template>
  <div class="youtube__iframe">
    <div v-if="info.thumbnail && !showVideo" class="youtube__iframe__thumbnail">
      <div
        @click="toggleView($event)"
        class="youtube__iframe__thumbnail__backdrop"
        :id="`thumbnail-video-${info.id}-${project}`"
      />
      <img loading="lazy" :src="thumbnailURL" :alt="info.title">
      <div class="youtube__iframe__thumbnail__icon" />
    </div>

    <transition name="fade">
      <iframe
        v-if="showVideo"
        :src="`https://www.youtube.com/embed/${info.id}?autoplay=1&modestbranding=1&rel=0&showinfo=0`"
        :title="info.title"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        :height="iframeConfig.height"
        :width="iframeConfig.width"
        allowfullscreen
      />
    </transition>

    <p>
      {{ info.title }}
    </p>

    <div class="youtube__iframe__share">
      <span>Compartilhe</span>
      <button class="btn__share btn__share__whatsapp" @click.prevent.stop="share('whatsapp')" />
      <button class="btn__share btn__share__facebook" @click.prevent.stop="share('facebook')" />
      <button class="btn__share btn__share__linkedin" @click.prevent.stop="share('linkedin')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerBox',
  props: {
    info: { type: Object, required: true }
  },
  data () {
    return {
      showVideo: false,
      iframeConfig: {
        height: 0,
        width: 0
      },
      project: process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis' ? 'equipamentos' : 'celular'
    }
  },
  computed: {
    thumbnailURL () {
      return `https://ciclic.imgix.net/thumbnails/${this.info.thumbnail}.png?auto=format,compress`
    }
  },
  methods: {
    toggleView (evt) {
      this.iframeConfig = {
        height: evt.target.clientHeight,
        width: evt.target.clientWidth
      }

      this.$nextTick(() => { this.showVideo = true })
    },
    share (media) {
      const mediaList = {
        whatsapp: {
          baseURL: 'https://api.whatsapp.com/send/?phone&',
          params: `text=https://www.youtube.com/watch?v=${this.info.id}&app_absent=0`
        },
        facebook: {
          baseURL: 'https://www.facebook.com/sharer/sharer.php?u=',
          params: `https://www.youtube.com/watch?v=${this.info.id}`
        },
        linkedin: {
          baseURL: 'https://www.linkedin.com/sharing/share-offsite/?url=',
          params: encodeURIComponent(`https://www.youtube.com/watch?v=${this.info.id}&feature=share`)
        }
      }

      const link = mediaList[media].baseURL + mediaList[media].params
      return window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.youtube__iframe {
  &__thumbnail {
    cursor: pointer;
    position: relative;

    img {
      filter: brightness(0.4);
      width: 100%;
    }

    &__backdrop {
      background: transparent;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 2;
    }

    &__icon {
      background-image: url('~@/assets/svg/icon-play.svg');
      height: 40px;
      left: calc(50% - 20px);
      position: absolute;
      top: calc(50% - 20px);
      width: 40px;
    }
  }

  iframe {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  }

  p {
    color: #1D2C53;
    font-family: Oscine, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin: 8px 0;
  }

  &__share {
    align-items: center;
    display: flex;

    span {
      color: #707070;
      font-family: Rubik, sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }

    button {
      height: 20px;
      margin-left: 12px;
      width: 20px;

      &.btn__share {
        background-size: cover;

        &__whatsapp {
          background-image: url('~@/assets/svg/icon-whatsapp-gray.svg');
        }

        &__facebook {
          background-image: url('~@/assets/svg/icon-facebook-gray.svg');
        }

        &__linkedin {
          background-image: url('~@/assets/svg/icon-linkedin-gray.svg');
        }
      }
    }
  }
}
</style>
